// Dev/staging switch for previewing an alternate Chakra design system (see src/theme/next/README.md).
// The cookie is read during SSR so server and client render the same system.

export const DESIGN_SYSTEM_COOKIE = 'scoDesignSystem'
export const DESIGN_SYSTEM_QUERY_PARAM = 'designSystem'

const OVERRIDE_KEYS = ['next']

export const isDesignSystemOverrideEnabled = process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production'

export const getDesignSystemOverride = (value?: string): string | undefined => {
  if (!isDesignSystemOverrideEnabled || !OVERRIDE_KEYS.includes(value)) {
    return undefined
  }
  return value
}
